module.exports = __webpack_public_path__ + "static/43-Spideo-da3b38e1062eb7275ddefbb03a31f3c9.png";